export default __webpack_public_path__ + "static/media/Education.2e9312c2.png";